import { Injectable } from '@angular/core';
import { Http, Response, Headers,ResponseContentType } from '@angular/http';
import 'rxjs/add/operator/map';
import { CONFIGURATION } from '../app.config';

@Injectable()
export class file1094Service {
    private _filemannagementUrl = CONFIGURATION.basefile1094CURL;

    constructor(private http: Http) { }

    get1094yearlist() {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json;charset=UTF-8');
        headers.append('Client-Id', 'HIC-REPORTING-API-CLIENT');
        headers.append('Client-Secret', 'f65ce994-e74e-11e7-80c1-9a214cf093ae');
        return this.http.get(this._filemannagementUrl + '1094c/tax-years', { headers: headers })
            .map((res: Response) => res.json());
    }
    get1094controlgroup(value: any) {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json;charset=UTF-8');
        headers.append('Client-Id', 'HIC-REPORTING-API-CLIENT');
        headers.append('Client-Secret', 'f65ce994-e74e-11e7-80c1-9a214cf093ae');
        return this.http.get(this._filemannagementUrl + '1094c/control-groups?taxYear=' + value, { headers: headers })
            .map((res: Response) => res.json());
    }
    get1094einlist(cg: any, year: any) {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json;charset=UTF-8');
        headers.append('Client-Id', 'HIC-REPORTING-API-CLIENT');
        headers.append('Client-Secret', 'f65ce994-e74e-11e7-80c1-9a214cf093ae');
        return this.http.get(this._filemannagementUrl + '1094c/ein-list?controlGroupName=' + cg + '&taxYear=' + year, { headers: headers })
            .map((res: Response) => res.json());
    }
    getIRSeinlist(taxYear: string, controlGroup: string, processStatus: string) {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json;charset=UTF-8');
        headers.append('Client-Id', 'HIC-REPORTING-API-CLIENT');
        headers.append('Client-Secret', 'f65ce994-e74e-11e7-80c1-9a214cf093ae');
        return this.http.get(this._filemannagementUrl +
            `submission/ein-list?processStatus=${processStatus}&controlGroupName=${controlGroup}&taxYear=${taxYear}`,
            { headers: headers })
            .map((res: Response) => res.json());
    }

    getAll1094BySearchCriteria(taxYear: number, ein: string, controlGroup: string, prodCompName: string) {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json;charset=UTF-8');
        headers.append('Client-Id', 'HIC-REPORTING-API-CLIENT');
        headers.append('Client-Secret', 'f65ce994-e74e-11e7-80c1-9a214cf093ae');
        if ('-1' === ein) ein = '';
        if ('-1' === controlGroup) controlGroup = '';
        if ('-1' === prodCompName) prodCompName = '';
        return this.http.get(this._filemannagementUrl +
            `1094c/getAll1094BySearchCriteria?taxYear=${taxYear}&controlGroup=${controlGroup}&ein=${ein}&productionCompany=${prodCompName}`, { headers: headers })
            .map((res: Response) => res.json());
    }
    getAll1095PDF(userId: any, year: string, ein: string,address:boolean) {
        const headers = new Headers();
        headers.append('Client-Id', 'HIC-REPORTING-API-CLIENT');
        headers.append('Client-Secret', 'f65ce994-e74e-11e7-80c1-9a214cf093ae');
    
        const params: URLSearchParams = new URLSearchParams();
        params.set('year', year);
        params.set('ein', ein);
        return this.http.get(this._filemannagementUrl + `1095c/generatePdf/${userId}?taxYear=${year}&ein=${ein}&address=${address}`,
          { headers: headers, search: params, responseType: ResponseContentType.Blob })
          .map((res: Response) => res
            // {
            //   return new Blob([res.blob()], { type: 'application/pdf' });
          );
      }

      getAll1094PDF(userId: any, year: string, ein: string,address:boolean) {
        const headers = new Headers();
        headers.append('Client-Id', 'HIC-REPORTING-API-CLIENT');
        headers.append('Client-Secret', 'f65ce994-e74e-11e7-80c1-9a214cf093ae');
    
        const params: URLSearchParams = new URLSearchParams();
        params.set('year', year);
        params.set('ein', ein);
        return this.http.get(this._filemannagementUrl + `1094c/generatePdf?taxYear=${year}&ein=${ein}`,
          { headers: headers, search: params, responseType: ResponseContentType.Blob })
          .map((res: Response) => res
            // {
            //   return new Blob([res.blob()], { type: 'application/pdf' });
          );
      }
}



// WEBPACK FOOTER //
// ./src/app/file1094/file1094.service.ts